import React from "react";

export default function BannerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "20px",
        height: "20px",
        marginLeft: "0.3rem",
      }}
      fill="#fcfcfc"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polyline
        points="40 216 40 48 40 48 224 48 176 108 224 168 40 168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
    </svg>
  );
}
